module.exports = __webpack_public_path__ + "img/works_titleist_a_btm.9e3b8baf.png";